import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4721a217"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "ml-2 pt-2" }
const _hoisted_4 = { class: "text-white block font-bold" }
const _hoisted_5 = { class: "text-gray-text" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-white mb-5" }, "CHANGE PASSWORD", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-gray-text mb-3" }, "It is recommended to change your password every 6 months.", -1))
const _hoisted_9 = { class: "md:flex mb-3 items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-44 my-2 md:my-0" }, "Old Password", -1))
const _hoisted_11 = { class: "flex-grow" }
const _hoisted_12 = { class: "input-group px-2 py-2 bg-black-body rounded-md w-full md:w-96 flex justify-between" }
const _hoisted_13 = ["type"]
const _hoisted_14 = {
  key: 0,
  class: "text-danger-primary"
}
const _hoisted_15 = { class: "md:flex mb-3 items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-44 my-2 md:my-0" }, "New Password", -1))
const _hoisted_17 = { class: "flex-grow" }
const _hoisted_18 = { class: "input-group px-2 py-2 bg-black-body rounded-md w-full md:w-96 flex justify-between" }
const _hoisted_19 = ["type"]
const _hoisted_20 = {
  key: 0,
  class: "text-danger-primary"
}
const _hoisted_21 = { class: "md:flex mb-3 items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-44 my-2 md:my-0" }, "Confirm New Password", -1))
const _hoisted_23 = { class: "flex-grow" }
const _hoisted_24 = { class: "input-group px-2 py-2 bg-black-body rounded-md w-full md:w-96 flex justify-between" }
const _hoisted_25 = ["type"]
const _hoisted_26 = {
  key: 0,
  class: "text-danger-primary"
}
const _hoisted_27 = { class: "md:flex mb-3 items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-44 my-2 md:my-0" }, null, -1))
const _hoisted_29 = { class: "flex-grow" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-white" }, "At least ONE capital letter, ONE number, and minumum 8 characters", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Forgot Password?")
const _hoisted_33 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_34 = {
  key: 0,
  class: "fixed z-50 inset-0 overflow-y-auto"
}
const _hoisted_35 = { class: "flex items-center justify-center min-h-full p-1 text-center sm:p-0" }
const _hoisted_36 = { class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:max-w-lg w-full m-2" }
const _hoisted_37 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_38 = { class: "modal-content bg-black-body text-white" }
const _hoisted_39 = { class: "modal-body p-10 text-justify z-50 relative" }
const _hoisted_40 = {
  key: 0,
  class: "text-gray-300 text-md mb-5 text-center font-bold"
}
const _hoisted_41 = { class: "border-0 pb-1 text-center" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "xr-icon-check my-4 text-blue-primary",
  style: {"font-size":"4em"}
}, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-300 text-md mb-5 text-center font-bold mt-4" }, "Password Link Sent", -1))
const _hoisted_45 = { class: "text-gray-text mb-2 p-2" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text mb-3 p-2 ps-0" }, "It is okay, click on the button below to reset your password", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.image,
        class: "rounded-full w-14 h-14 border-4 border-gray-300"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentCompany), 1),
        _createElementVNode("span", _hoisted_5, "Username: " + _toDisplayString(_ctx.user.username), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: _ctx.showPassword?'text':'password',
              class: "form-control",
              name: "Password",
              required: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.oldPassword) = $event))
            }, null, 8, _hoisted_13), [
              [_vModelDynamic, _ctx.state.oldPassword]
            ]),
            _createElementVNode("span", {
              class: "btn btn-showPassword",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
            }, [
              (_ctx.showPassword)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "fa-solid fa-eye-slash",
                    class: "text-gray-text"
                  }))
                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: "fa-solid fa-eye",
                    class: "text-gray-text"
                  }))
            ])
          ]),
          (_ctx.v$.oldPassword.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.v$.oldPassword.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              type: _ctx.showNewPassword?'text':'password',
              class: "form-control",
              name: "newPassword",
              required: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.password) = $event))
            }, null, 8, _hoisted_19), [
              [_vModelDynamic, _ctx.state.password]
            ]),
            _createElementVNode("span", {
              class: "btn btn-showPassword",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showNewPassword = !_ctx.showNewPassword))
            }, [
              (_ctx.showNewPassword)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "fa-solid fa-eye-slash",
                    class: "text-gray-text"
                  }))
                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: "fa-solid fa-eye",
                    class: "text-gray-text"
                  }))
            ])
          ]),
          (_ctx.v$.password.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.v$.password.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              type: _ctx.showConfirmPassword?'text':'password',
              class: "form-control",
              name: "newPassword",
              required: "",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.confirmPassword) = $event))
            }, null, 8, _hoisted_25), [
              [_vModelDynamic, _ctx.state.confirmPassword]
            ]),
            _createElementVNode("span", {
              class: "btn btn-showPassword",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showConfirmPassword = !_ctx.showConfirmPassword))
            }, [
              (_ctx.showConfirmPassword)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "fa-solid fa-eye-slash",
                    class: "text-gray-text"
                  }))
                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: "fa-solid fa-eye",
                    class: "text-gray-text"
                  }))
            ])
          ]),
          (_ctx.v$.confirmPassword.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.v$.confirmPassword.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("button", {
            class: "btn-primary text-white mt-8",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)))
          }, "Save New Password"),
          _hoisted_31,
          _createElementVNode("a", {
            href: "#",
            class: "block text-blue-primary mt-4 inline-block",
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.isDisplayForgetPasswordModal = true), ["prevent"]))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-solid fa-key",
              class: "text-blue-primary inline-block mr-2"
            }),
            _hoisted_32
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayForgetPasswordModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayForgetPasswordModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isDisplayForgetPasswordModal = false))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-close",
                            class: "text-gray-text p-0 text-end inline-block text-sm"
                          })
                        ]),
                        (!_ctx.resetPasswordSent)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, "Password Reset"))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_41, [
                          (_ctx.resetPasswordSent == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _hoisted_43,
                                _hoisted_44,
                                _createElementVNode("p", _hoisted_45, "Please check your inbox " + _toDisplayString(_ctx.user.email), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.resetPasswordSent == false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _hoisted_47,
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "my-3 inline-block form-control disabled px-4 py-4 rounded-md ny-3",
                                  id: "email-address",
                                  placeholder: "Email Address",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.email) = $event)),
                                  disabled: ""
                                }, null, 512), [
                                  [_vModelText, _ctx.user.email]
                                ]),
                                _createElementVNode("button", {
                                  class: "btn btn-primary my-5 mt-5",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.forgotPassword()))
                                }, "Send Reset Password Link")
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}